import { Component } from "../../core/Component";
import { transporter } from "../../core/transporter";
import axios from "axios";
export class FileComponent extends Component {
  DUPLICATE_EXTENSIONS = {
    tiff: {
      mimetype: "image/tiff",
      extension: "tiff"
    }
  };

  // static className = "qform-row";

  constructor($root, options) {
    super($root, options);
    this.options = options;
    this.messages = options.messages;
    this.fieldId = options.id;
    this.formId = options.formId;
    this.domain = options.domain;
    this.typeId = options.typeId;
    this.label = options.label || "";
    this.hint = options.hint || "";
    this.type = options.type || "file";
    this.mimetypes = options.mimetypes || "";
    this.allMimtypes = ["aac", "abw", "avi", "bmp", "css", "csv", "doc", "docx", "eot", "gif", "htm", "html", "ico", "jpeg", "jpg", "m4a", "mp3", "mpeg", "mp4", "mov", "odp", "ods", "odt", "oga", "ogv", "ogg", "otf", "png", "pdf", "ppt", "pptx", "rtf", "svg", "tar", "tif", "tiff", "txt", "wav", "weba", "webm", "webp", "woff", "woff2", "xls", "xlsx", "xml", "zip", "psd", "ps", "ai", "eps", "xml", "rar"].join(",");
    // this.maxSize = 1073741824; // 1Gb
    // this.maxSize = 209715200; // 200Mb

    this.maxSize = options.maxSize * 1024 ** 2; // 1Mb
    this.maxOverallSize = 1024 ** 3; // 1Gb;
    this.multiple = options.multiple ? "multiple" : "";
    this.maxCountFiles = options.multiple ? 10 : 1;
    this.qoutsUploadActive = options.uploadActive;
    this.require = this.qoutsUploadActive ? options.required === 1 : false;
    this.placeholder = this.messages.inputFileDownload || options.placeholder;
    this.classes = options.classes || "";
    // установка пользовательских классов оформления
    // this.setUserClasses()
    this.wrapClasses = this.makeWrapUserClasses();
    this.name = `${options.name}`;
    this.id = `${options.name}_${options.formId}_${options.formIndex}`;
    this.dropzoneId = `label_${options.name}`;
    this.loaderNameId = `${options.name}_${options.formIndex}_loader`;
    this.listNameId = `${options.name}_${options.formIndex}_list`;
    this.cartNameId = `${options.name}_${options.formIndex}_cart`;
    this.dropzoneContentId = `dropzone-content__${options.formId}_${options.formIndex}_${options.name}`;
    this.labelId = `${options.name}_label`;
    this.boxId = `${options.name}_${options.formIndex}_box`;
    this.errorBox = `${options.name}_${options.formIndex}_error-box`;
    this.errorBoxText = `${options.name}_${options.formIndex}_error-box_text`;
    this.fileFieldType = options.fileFieldType || 1;
    this.fileDropzoneType = options.fileDropzoneType || 1;
    this.file = [];
    this.invalidMimtypeFiles = [];
    this.invalidFileSizeFiles = [];
    this.invalidExtentionFiles = [];
    this.attachedFilesCount = 0;
    this.uploadQueue = [];
    this.inLoadState = false;
    this.isOverallFilesSizeError = false;
    this.Emitter = options.Emitter;
  }
  init() {
    let {
      disable = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.$inputFile = this.$root.$el.querySelector(`#${this.id}`);
    this.$inputFile.disabled = disable;
    this.$dropzone = this.$root.$el.querySelector(`#${this.dropzoneId}`);
    this.$label = this.$root.$el.querySelector(`#${this.labelId}`);
    this.$box = this.$root.$el.querySelector(`#${this.boxId}`);
    this.$errorBox = this.$root.$el.querySelector(`#${this.errorBox}`);
    this.$errorBoxText = this.$root.$el.querySelector(`#${this.errorBoxText}`);
    this.$dropzoneContent = this.$root.$el.querySelector(`#${this.dropzoneContentId}`);
    if (!disable) {
      this.listeners = [{
        eventName: "dragover",
        method: "onDragover",
        el: this.$dropzone
      }, {
        eventName: "dragenter",
        method: "onDragover",
        el: this.$dropzone
      }, {
        eventName: "dragleave",
        method: "onDragleave",
        el: this.$dropzone
      }, {
        eventName: "drop",
        method: "onDrop",
        el: this.$dropzone
      }, {
        eventName: "change",
        method: "onChangeFile",
        el: this.$inputFile
      }];
      //подписываемся на событие полной очистки списка
      this.Emitter.subscribe(`full-cleared-${this.id}`, () => {
        this.file = [];
        this.$inputFile.value = "";
        this.inLoadState = false;
        this.invalidMimtypeFiles = [];
        this.invalidFileSizeFiles = [];
        this.invalidExtentionFiles = [];
        this.setMassageValid();
        //событие для запуска валидации всей формы
        this.Emitter.emit("Change:field", {});
      });
      //подписываемся на событие переключения аттрибута "disabled" кнопки загрузки файлов
      this.Emitter.subscribe(`toggle-upload-btn-${this.id}`, isDisabled => this.toggleUploadButtonActive(isDisabled));
      this.$dropzone.addEventListener("click", () => {
        this.$inputFile.click();
      });
      //при удалении файла из списка проверяем, был ли файл валидным
      this.Emitter.subscribe(`deleted-${this.id}`, _ref => {
        let {
          id,
          filename,
          size
        } = _ref;
        this.allFileSize -= size;
        if (this.invalidMimtypeFiles.includes(filename)) {
          this.invalidMimtypeFiles.splice(this.invalidMimtypeFiles.findIndex(file => file === filename), 1);
        }
        if (this.invalidFileSizeFiles.includes(filename)) {
          this.invalidFileSizeFiles.splice(this.invalidFileSizeFiles.findIndex(file => file === filename), 1);
        }
        if (this.invalidExtentionFiles.join(",").includes(filename)) {
          this.invalidExtentionFiles.splice(this.invalidExtentionFiles.findIndex(file => file === filename), 1);
        }
        const fileIndex = this.file.findIndex(file => file.file_id === id);
        if (fileIndex !== -1) {
          this.file.splice(fileIndex, 1);
        }
        this.validation();
        this.isCopyLoaded = false;
        //событие для запуска валидации всей формы
        this.Emitter.emit("Change:field", {});
      });
      //подписываемся на событие изменения количества файлов в списке файлов
      this.Emitter.subscribe(`files-count-${this.id}`, count => {
        this.attachedFilesCount = count;
        this.validation();
      });
      this.getFileWidget();
      this.count = this.$inputFile.files.length;
    }
    super.init();
    this.allFileSize = 0;
  }
  toHTML() {
    return `
    <div class="qform-field file 
    ${this.hint ? "qform-hint" : ""} 
    ${this.wrapClasses ? this.wrapClasses?.join(" ") : ""}"
    id="${this.boxId}">
      <div class="qform-field_wrap">
      ${this.toHtmlOutLabelBox()}
      <div class="qform-field__block">
          <div class="qform-field__block_box">
            <div>
              <div class="qform-field__block_box__field-box__file ${this.classes}">
                <button type="button" class="qform-field__block_box__field-box__dropzone ${this.options.formWidth < 550 && this.options.formWidth !== 0 ? "no-padding" : ""}"
                  
                  ${!this.qoutsUploadActive ? "disabled" : ""} 
                  id="${this.dropzoneId}"
                >
                  <div class="qform-field__block_box__field-box__dropzone_placeholder dropzone_placeholder">${this.messages.inputFileDownload}</div>
                  <input
                    class="qform-field__block_box__field-box__input"
                    id="${this.id}"
                    name="${this.name}"
                    ${!this.qoutsUploadActive ? "disabled" : ""} 
                    ${this.multiple}
                    ${this.getAccept(this.mimetypes || this.allMimtypes)}
                    type="file"
                    autocomplete="off"
                  >
                </button>
                <div
                  class="qform-field__block_box__field-box__view filefield-here"
                  data-input_id="${this.id}"
                  data-dropzone_type="${this.fileDropzoneType}"
                  data-loader_name_id="${this.loaderNameId}"
                  data-list_name_id="${this.listNameId}"
                  data-cart_name_id="${this.cartNameId}"
                  data-max_count_files="${this.maxCountFiles}"
                  id="${this.dropzoneContentId}"
                >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      ${this.toHtmlBottomBox()}
    </div>
    `;
  }

  /**
   * @param handler {cb: () => Function}
   * @return Function
   * */
  onProgress(handler) {
    return data => {
      this.validation();
      const loaded = data.loaded;
      const size = data.total;
      const progressValue = loaded && size ? loaded / size * 100 : 0;
      if (this.uploadQueue[0] && this.uploadQueue[0].body) {
        this.emitProgress(this.uploadQueue[0].body.file_id, progressValue);
      }
      if (loaded === size) {
        if (!this.uploadQueue.length) {} else if (handler) {
          handler();
        }
      }
    };
  }

  //формирование списка поддерживаемых форматов файлов для загрузки
  /**
   * @param mimeType {Array<{id: number, extension: string, mimetype: string}>} - Массив с типами файлов
   * */
  getAccept(mimeType) {
    return mimeType.length ? `accept="${mimeType.map(el => el.mimetype).join(", ").replace(/font\//g, ".")}"` : false;
  }
  getValue() {
    let files = [];

    // this.getDeletedFiles();

    for (let i = 0; i < this.file.length; i++) {
      files.push(JSON.stringify(this.file[i]));
    }
    return {
      id: this.fieldId,
      name: this.name,
      typeId: this.typeId,
      values: files
    };
  }
  async setClassField(data) {
    if (data && typeof data.formStyleFile !== "undefined") {
      if (data.formStyleFile.type === 0) {
        this.$dropzone.classList.add("button");
      } else if (data.formStyleFile.type === 1) {
        this.$dropzone.classList.add("area");
      }
    }
    if (data && typeof data.formStyleFile !== "undefined" && typeof data.formStyleFile.preloaderType === "number") {
      this.$dropzoneContent.dataset.dropzone_type = data.formStyleFile.preloaderType;
    }
    if (!data.formStyleFile.useDesign) {
      // // console.log('Удаляю класс File')
      let arrClass = this.$root.$el.classList.value.split(" ");
      arrClass.forEach(nameClass => {
        if (nameClass.trim()) {
          this.$root.$el.classList.remove(nameClass);
        }
      });
    }
    if (data && typeof data.formStyleFieldRequired !== "undefined") {
      if (data.formStyleFieldRequired.type === 0 && this.require) {
        this.$box.classList.add("required");
      } else if (data.formStyleFieldRequired.type === 1 && !this.require) {
        this.$box.classList.add("not-required");
      }
      if (!data.formStyleFieldRequired.useDesign) {
        this.$box.classList.remove("required");
        this.$box.classList.remove("not-required");
      }
    }
  }
  getFileWidget() {
    import(/* webpackChunkName: "FileWidgetComponent" */"./FileWidget.component").then(_ref2 => {
      let {
        QFileWidget
      } = _ref2;
      let fileWidget = new QFileWidget(this.$dropzoneContent, this.options.mimetypes, this.messages, this.uploadQueue, this.Emitter, this.maxSize);
      fileWidget.init();
    });
  }
  onDragover(event) {
    event.preventDefault();
    this.$dropzone.classList.add("light");
  }
  onDragleave(event) {
    event.preventDefault();
    this.$dropzone.classList.remove("light");
  }
  onDrop(event) {
    event.preventDefault();
    this.$dropzone.classList.remove("light");
    if (this.multiple.length > 0) {
      this.$inputFile.files = event.dataTransfer.files;
    }
    let eventFile = new Event("change");
    this.$inputFile.dispatchEvent(eventFile);
    this.validation();
  }

  //переключение активности кнопки загрузки файлов
  /**
   * @param isDisabled {Boolean} -
   * */
  toggleUploadButtonActive(isDisabled) {
    if (isDisabled) {
      this.$dropzone.setAttribute("disabled", "disabled");
      this.$dropzone.setAttribute("title", this.messages.inputFileRemove);
    } else {
      this.$dropzone.removeAttribute("disabled");
      this.$dropzone.removeAttribute("title");
    }
  }

  /**
   * @param event {Event<HTMLInputElement>} - Ивент при выборе файлов
   * */
  onChangeFile(event) {
    event.preventDefault();
    event.stopPropagation();
    /**
     * @const files
     * @type FileList
     * */
    const files = this.$inputFile.files;
    const newFilesSize = Array.from(files).reduce((acc, f) => acc + f.size, 0);
    if (this.allFileSize + newFilesSize > this.maxOverallSize) {
      this.isOverallFilesSizeError = true;
      this.setMassageValid(this.messages.inputFilesSize + ` (${this.maxOverallSize / (1024 * 1024)}Mb)`);
      this.inLoadState = false;
      return;
    }
    this.inLoadState = true;
    this.isCopyLoaded = false;
    this.isOverallFilesSizeError = false;

    // Проверка на превышение общего размера файлов
    if (this.allFileSize > this.maxOverallSize) {
      this.isOverallFilesSizeError = true;
      this.setMassageValid(this.messages.inputFilesSize + ` (${this.maxOverallSize / (1024 * 1024)}Mb)`);
      this.inLoadState = false;
      return;
    }
    let i = 0;
    for (const f of files) {
      const index = i + this.file.length;
      this.allFileSize += f.size;
      if (!this.invalidMimtypeFiles.includes(f.name) && !this.invalidFileSizeFiles.includes(f.name) && !this.invalidExtentionFiles.includes(f.name)) {
        f.isValidMimtype = this.checkValidMimetype(f);
        f.isValidFileSize = this.checkValidFileSize(f.size);
        if (!f.isValidMimtype && !this.invalidMimtypeFiles.includes(f.name)) {
          this.invalidMimtypeFiles.push(f.name);
          this.count = this.count - 1;
          continue;
        }
        if (!f.isValidFileSize && !this.invalidFileSizeFiles.includes(f.name)) {
          this.invalidFileSizeFiles.push(f.name);
          this.count = this.count - 1;
          continue;
        }
        const extension = f.name.split(".").pop() || this.messages.inputFileUnknown;
        const obj = {
          body: {
            file_id: String(f.lastModified) + String(f.size) + i,
            formId: this.formId,
            domain: this.domain,
            fieldId: this.fieldId,
            typeId: this.typeId,
            name: f.name,
            mimetype: f.type,
            extension
          },
          index,
          size: f.size,
          isValidMimtype: f.isValidMimtype,
          isValidFileSize: f.isValidFileSize,
          loaded: false,
          file: f
        };
        this.uploadFile(obj);
      }
      i++;
    }
    this.$emit("Change:field", {});
  }
  /**
   * Проверьте, является ли расширение файла для данного имени файла допустимым типом MIME в соответствии с предоставленным списком расширений.
   *
   * @param {File} file - Имя файла, включая его расширение.
   * @returns {boolean} Возвращает значение true, если расширение файла является допустимым типом MIME, в противном случае значение false.
   */
  checkValidMimetype(file) {
    const fileExtension = file.name.split(".").pop().toLowerCase();
    if (!this.mimetypes?.length) {
      return true;
    } else {
      if (this.DUPLICATE_EXTENSIONS[fileExtension]) {
        this.mimetypes.push(this.DUPLICATE_EXTENSIONS[fileExtension]);
      }
      return !!this.mimetypes.find(elem => elem.extension === fileExtension);
    }
  }

  /**
   * Проверяет, находится ли указанный размер файла в разрешенном диапазоне.
   *
   * @param {number} fileSize - Размер проверяемого файла.
   * @returns {boolean} Возвращает true, если размер файла больше 0 и не превышает this.maxSize, в противном случае возвращает false.
   */
  checkValidFileSize(fileSize) {
    return fileSize > 0 && fileSize <= this.maxSize;
  }

  /**
   * Проверяет общий размер файлов в массиве.
   *
   * @param {FileList} files - Массив объектов файлов, каждый объект должен иметь свойство 'size'.
   * @returns {boolean} Возвращает true, если общий размер всех файлов меньше максимально допустимого размера, в противном случае - false.
   */
  checkOverallFilesSize(files) {
    let overallFilesSize = 0;
    for (let file of files) {
      overallFilesSize += file.size;
    }
    return overallFilesSize < this.maxOverallSize;
  }
  async uploadFile(fileObject) {
    //проверка при прикреплении в режиме одного файла
    const controlFileSize = 50 * 1024 * 1024; // 50 Mb
    if (fileObject.size <= controlFileSize) {
      let formData = new FormData();
      formData.set("file", fileObject.file);
      formData.set("data", JSON.stringify({
        form_field: this.fieldId,
        type_id: fileObject.body.typeId,
        file_id: fileObject.body.file_id,
        file_name: fileObject.body.name,
        mimetype: fileObject.body.mimetype,
        ext: fileObject.body.extension,
        domain: this.domain,
        form_id: this.formId,
        file_size: fileObject.size
      }));
      const url = `https://${process.env.UPLOAD_HOST}${this.options.upload_controller}`;
      await transporter.post(url, {
        body: formData,
        options: {
          method: "POST",
          headers: {}
        },
        //хук для отслеживания полной загрузки файла
        onprogress: this.onProgress(() => {
          this.validation();
        }),
        callbackError: err => {
          if (err.readyState === 4) this.onUploadError(err);
        },
        callback: data => {
          this.pushFile(data);
        }
      });
    } else {
      const file = fileObject.file;
      const fileUuid = getUUID();
      const chunkSize = 50 * 1024 * 1024; // 50mb
      //адрес для запросов
      const url = `https://${process.env.UPLOAD_HOST}${this.options.upload_controller_chunks}`;
      //счетчик для нейминга частей файла по порядку
      let counter = 1;
      for (let start = 0; start < fileObject.size; start += chunkSize) {
        const chunkEnd = Math.min(start + chunkSize, file.size);
        let chunk = file.slice(start, chunkEnd);
        let action = "middle";
        if (start === 0) {
          action = "start";
        } else if (start + chunkSize >= file.size) {
          action = "end";
        }
        let formData = new FormData();
        formData.set("data", JSON.stringify({
          file_name: fileObject.body.name,
          uuid_file: fileUuid,
          form_field: this.fieldId,
          type_id: fileObject.body.typeId,
          file_id: fileObject.body.file_id,
          mimetype: fileObject.body.mimetype,
          ext: fileObject.body.extension,
          action: action,
          domain: this.domain,
          form_id: this.formId
        }));
        formData.set("file", chunk, `blob_${counter}`);
        try {
          const {
            data
          } = await axios.post(url, formData, {
            params: {
              blob: counter,
              filename: fileObject.body.name
            }
          }).then(res => {
            counter++;
            return res;
          });
          formData = null;
          chunk = null;
          this.validation();
          const progressValue = chunkEnd / file.size * 100;
          this.emitProgress(fileObject.body.file_id, progressValue);
          //если  пришло имя и ключ файла, значит, файл был полностью загружен
          if (data.filename && data.objectKey) {
            this.pushFile(data);
            this.validation();
          }
        } catch (e) {
          console.error(e);
          this.onUploadError(e);
        }
      }
    }
  }
  onUploadError() {
    this.setMassageValid("Ошибка при загрузке файлов");
    this.Emitter.emit("network-error");
    this.Emitter.emit(`unlock-clear-all-${this.id}`);
  }
  emitProgress(id, progressValue) {
    this.Emitter.emit("progress", {
      id,
      progress: progressValue
    });
  }
  pushFile(data) {
    if (data.objectKey && data.filename) {
      this.file.push({
        file_id: data.file_id,
        fileUrl: data.objectKey,
        filename: data.filename
      });
      this.Emitter.emit("loaded", data.file_id);
      this.uploadQueue.splice(this.uploadQueue.indexOf(this.uploadQueue.find(el => el.body.file_id === data.file_id)), 1);
    } else {
      if (data.error && data.error === "Mimetype doesn't compare to extension.") {
        if (!this.invalidExtentionFiles.join(",").includes(data.filename)) {
          this.invalidExtentionFiles.push(data.filename);
          this.Emitter.emit("server-error", data.filename);
        }
      }
    }
    if (this.file.length + this.invalidFileSizeFiles.length + this.invalidMimtypeFiles.length + this.invalidExtentionFiles.length === this.attachedFilesCount) {
      this.Emitter.emit("Change:field", {});
    }
    this.uploadFile(data);
  }
  validation() {
    let setMessageValid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let errorMessage = "";
    let valid = true;
    //если превышен общий размер файлов
    if (this.isOverallFilesSizeError) {
      this.Emitter.emit(`unlock-clear-all-${this.id}`);
      this.inLoadState = false;
      errorMessage = this.messages.inputFilesSize + ` (${this.maxOverallSize / (1024 * 1024)}Mb)`;
      valid = false;
    }

    //проверяем, все ли файлы обработаны и подготовлены к загрузке
    if (this.file.length + this.invalidFileSizeFiles.length + this.invalidMimtypeFiles.length + this.invalidExtentionFiles.length === this.attachedFilesCount && this.file.length !== 0) {
      this.Emitter.emit(`unlock-clear-all-${this.id}`);
      this.inLoadState = false;
    }

    //проверка на превышение максимального количества прикрепляемых файлов
    if (this.file.length > this.maxCountFiles) {
      errorMessage = this.messages.inputFileQuantity.replace("{0}", this.maxCountFiles);
      valid = false;
      this.setMassageValid(errorMessage);
    }
    //проверка на заполнение для обязательного поля
    if (this.require && !this.invalidMimtypeFiles.length && !this.invalidFileSizeFiles.length && +!this.invalidExtentionFiles.length && !this.attachedFilesCount && !this.inLoadState && setMessageValid) {
      errorMessage = this.messages.inputFileRequired;
      valid = false;
    } else if (this.invalidMimtypeFiles.length && this.invalidFileSizeFiles.length && this.invalidExtentionFiles.length) {
      errorMessage = this.messages.inputFilesFormat + "<br>" + this.messages.inputFilesSize;
      valid = false;
    } else if (this.invalidMimtypeFiles.length || this.invalidExtentionFiles.length) {
      errorMessage = this.messages.inputFilesFormat;
      valid = false;
    } else if (this.invalidFileSizeFiles.length) {
      errorMessage = this.messages.inputFilesSize + ` (${this.maxSize / (1024 * 1024)}Mb)`;
      valid = false;
    }
    //процесс загрузки файла
    else if (this.inLoadState) {
      valid = false;
      errorMessage = this.$inputFile.files.length > 1 ? this.messages.inputFilesWait : this.messages.inputFileWait;
    }
    if (this.isCopyLoaded) {
      errorMessage += "<br>" + this.messages.inputFileAlreadyUpload;
    }
    this.setMassageValid(errorMessage);
    return valid;
  }
  reset() {
    this.file = [];
    // this.deleteFiles = [];
    // this.$inputFile.dataset.reset = "1";
    this.$inputFile.dispatchEvent(new Event("change"));
  }
}
function getUUID() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}